import { GenericError } from "components/errorBoundary/ErrorBoundary";

export default function Error500() {
  return (
    <GenericError
      fullPage
      error={Error(
        "500. An unexpected server error occurred. Please try again later."
      )}
    />
  );
}
